import { render, staticRenderFns } from "./accessoryMaterialDetail.vue?vue&type=template&id=f229ceee&scoped=true"
import script from "./accessoryMaterialDetail.vue?vue&type=script&lang=js"
export * from "./accessoryMaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./accessoryMaterialDetail.vue?vue&type=style&index=0&id=f229ceee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f229ceee",
  null
  
)

export default component.exports